export const TOAST_SHOW = "TOAST_SHOW";
export const TOAST_HIDE = "TOAST_HIDE";

export const TOAST_TYPE_SUCCESS = "success";
export const TOAST_TYPE_WARNING = "warning";
export const TOAST_TYPE_INFO = "info";
export const TOAST_TYPE_ERROR = "error";

export const toastMsg =
  (message, severity = TOAST_TYPE_SUCCESS) =>
  (dispatch) => {
    dispatch({
      type: TOAST_SHOW,
      message: message,
      severity: severity,
    });
  };
export const toastEnd = () => (dispatch) => {
  dispatch({
    type: TOAST_HIDE,
  });
};
